import S3 from 'aws-sdk/clients/s3'

// import S3 from 'react-aws-s3';
window.Buffer = window.Buffer || require('buffer').Buffer

const signatureVersion = 'v4'
const accessKeyId = process.env.REACT_APP_AWS_ACCESS_KEY
const secretAccessKey = process.env.REACT_APP_AWS_KEY_SECRET

const MUNROE_BUCKET_NAME = 'munroe-app-data'
const ACCELERATED_ENDPOINT = process.env.REACT_APP_ACCELERATED_END_POINT
interface UploadFileOptions {
  file: any
  title: string
  type: string
}

const uploadDirectOnS3 = async ({file, title, type}: UploadFileOptions): Promise<any> => {
  const s3bucket = new S3({
    accessKeyId: accessKeyId,
    secretAccessKey: secretAccessKey,
    signatureVersion: signatureVersion,
    //endpoint: ACCELERATED_ENDPOINT,
  })

  const keyName = `${type}/${title}/${file.name}`
  const params = {
    Bucket: MUNROE_BUCKET_NAME,
    Key: keyName,
    Body: file,
  }

  try {
    const {Location} = await s3bucket.upload(params).promise()
    return Location
  } catch (err) {
    throw err
  }
}

interface UploadFileOptionsP {
  file: File
  title: string
  type: string
  onProgress?: (progress: number) => void
}

const uploadDirectOnS3Progress = async ({
  file,
  title,
  type,
  onProgress,
}: UploadFileOptionsP): Promise<any> => {
  console.log('S3 Upload - Starting:', {
    fileName: file.name,
    fileSize: file.size,
    fileType: file.type,
    title,
    type,
    hasAccessKey: !!accessKeyId,
    hasSecretKey: !!secretAccessKey,
  })

  if (!accessKeyId || !secretAccessKey) {
    const error = new Error('S3 credentials not configured. Check REACT_APP_AWS_ACCESS_KEY and REACT_APP_AWS_KEY_SECRET environment variables.')
    console.error('S3 Upload - Missing credentials:', error)
    throw error
  }

  const s3bucket = new S3({
    accessKeyId: accessKeyId,
    secretAccessKey: secretAccessKey,
    signatureVersion: signatureVersion,
    region: 'us-east-1', // Add region to avoid potential issues
    //endpoint: ACCELERATED_ENDPOINT,
  })

  // Sanitize filename to avoid issues
  const sanitizedFileName = file.name.replace(/[^a-zA-Z0-9.-]/g, '_')
  const keyName = `${type}/${title}/${sanitizedFileName}`
  
  const params = {
    Bucket: MUNROE_BUCKET_NAME,
    Key: keyName,
    Body: file,
    ContentType: file.type, // Explicitly set content type
  }

  console.log('S3 Upload - Params:', {bucket: params.Bucket, key: params.Key, contentType: params.ContentType})

  try {
    // Create a managed upload
    const managedUpload = s3bucket.upload(params)

    // Add progress listener if onProgress callback is provided
    if (onProgress) {
      managedUpload.on('httpUploadProgress', (progress) => {
        const percentage = Math.round((progress.loaded * 100) / progress.total)
        console.log('S3 Upload - Progress:', percentage + '%', {loaded: progress.loaded, total: progress.total})
        onProgress(percentage)
      })
    }

    // Wait for upload to complete and get result
    const result = await managedUpload.promise()
    console.log('S3 Upload - Success:', result.Location)
    return result.Location
  } catch (err: any) {
    console.error('S3 Upload - Error:', {
      message: err?.message,
      code: err?.code,
      statusCode: err?.statusCode,
      name: err?.name,
      retryable: err?.retryable,
    })
    
    // Provide more helpful error messages
    if (err?.code === 'NetworkingError') {
      console.error('S3 Upload - This might be a CORS issue. Check your S3 bucket CORS configuration.')
    } else if (err?.code === 'AccessDenied' || err?.statusCode === 403) {
      console.error('S3 Upload - Access denied. Check your S3 bucket policy and IAM permissions.')
    } else if (err?.code === 'CredentialsError') {
      console.error('S3 Upload - Invalid credentials. Check your AWS access key and secret.')
    }
    
    throw err
  }
}

const uploadImageOnS3 = async ({file, title, type}: UploadFileOptions): Promise<any> => {
  const s3bucket = new S3({
    accessKeyId: accessKeyId,
    secretAccessKey: secretAccessKey,
    //signatureVersion: signatureVersion,
    //endpoint: ACCELERATED_ENDPOINT,
  })

  const keyName = `${type}/${title.replace(/-/g, ' ')}/${file.name.replace(/-/g, ' ')}`
  const params = {
    Bucket: MUNROE_BUCKET_NAME,
    Key: keyName,
  }

  try {
    // Step 1: Create a multipart upload
    const {UploadId} = await s3bucket.createMultipartUpload(params).promise()
    const parts = []

    // Step 2: Upload parts of the file
    const fileSize = file.size
    const partSize = 10 * 1024 * 1024 // 10MB per part (adjust as needed)
    let start = 0
    let partNumber = 1
    let uploadedBytes = 0
    const totalParts = Math.ceil(fileSize / partSize) // Calculate the total nu

    while (start < fileSize) {
      const end = Math.min(start + partSize, fileSize)

      const partParams = {
        ...params,
        PartNumber: partNumber,
        UploadId: UploadId!,
        Body: file.slice(start, end),
      }

      const {ETag} = await s3bucket
        .uploadPart(partParams)
        .on('httpUploadProgress', (progress) => {
          const uploaded = progress.loaded
          uploadedBytes += uploaded
          const partProgress = Math.round((uploaded / partSize) * 100) // Progress for each part
          const overallProgress = Math.round((partNumber / totalParts) * 100) // Overall progress
        })
        .promise()
      parts.push({PartNumber: partNumber, ETag: ETag})

      start = end
      partNumber++
    }

    // Step 3: Complete the multipart upload
    const completeParams = {
      ...params,
      UploadId: UploadId!,
      MultipartUpload: {Parts: parts},
    }

    const {Location} = await s3bucket.completeMultipartUpload(completeParams).promise()
    return Location
  } catch (err) {
    throw err
  }
}

export {uploadImageOnS3, uploadDirectOnS3, uploadDirectOnS3Progress}

export default uploadImageOnS3
